import ProjectDashboardModule from './project-dashboard.module'

export default ProjectDashboardModule
